export const listingDetail = {
  breadcrumb: {
    listings: "Annunci",
    detailFallback: "Dettaglio",
  },
  hero: {
    noName: "Senza nome",
    editNameTitle: "Modifica nome",
    channelConnected: "Collegato al canale (OTA)",
    channelDisconnected: "Non collegato al canale",
  },
  units: {
    unitsCount: "{count} unità",
    roomsCount: "{count} camera | {count} camere",
    maxGuests: "Max. {count} ospiti",
    searchPlaceholder: "Cerca unità…",
    dragTitle: "Trascina per riordinare",
    headerRoomTypes: "TIPI DI CAMERA",
    headerLinkedUnits: "UNITÀ COLLEGATE",
    addBtnTitle: "Aggiungi unità",
    movedBadge: "spostato",
    unitFallback: "Unità",
  },
  typeLabels: {
    apartment: "Appartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Camera",
    studio: "Monolocale",
    fallback: "Alloggio",
  },
  aiReception: {
    title: "Reception IA",
  },
  toggles: {
    enableAgent: {
      label: "Abilita agente IA",
      hint: "Automatizza l'assistenza agli ospiti tramite WhatsApp.",
    },
    otaAgent: {
      label: "Agente IA per le OTA",
      hintOn: "Risponde anche ai messaggi da Booking, Airbnb e altre OTA.",
      hintOff: "Richiede che l'agente IA sia attivo.",
    },
  },
  status: {
    active: "Attivo",
    inactive: "Inattivo",
  },
  emptyUnits: {
    title: "Nessuna unità",
    subHotel: "Crea la prima camera o unità di questo hotel per iniziare a configurare tariffe e disponibilità.",
    subDefault: "Aggiungi la prima unità a questo annuncio per iniziare a ricevere ospiti.",
    ctaPreparing: "Preparazione…",
    ctaAddRoom: "Aggiungi camera",
    ctaAddFirstUnit: "Aggiungi prima unità",
  },
  sortBar: {
    add: "Aggiungi",
    addRoom: "Aggiungi camera",
    saving: "Salvataggio…",
    done: "Fatto",
    sort: "Riordina",
    dragHint: "Trascina per riordinare",
  },
  propOptions: {
    scheduled: "Messaggi programmati",
    services: "Dotazioni e comfort",
    locks: "Serrature",
    faq: "Domande e risposte",
    arrival: "Istruzioni per l'arrivo",
    checkout: "Messaggio di check-out",
    welcome: "Messaggio di benvenuto",
    description: "Descrizione",
    capacity: "Capacità",
  },
  addZone: {
    titleRoom: "Aggiungi camera",
    titleUnit: "Aggiungi unità",
    roomLower: "camera",
    unitLower: "unità",
    createNew: "Crea una nuova {noun} all'interno",
    eachHas: "Ogni {noun} ha le proprie impostazioni (descrizione, capacità, accesso…).",
    ctaPreparing: "Preparazione…",
    ctaCreateRoom: "Crea camera",
    ctaCreateUnit: "Crea unità",
  },
  danger: {
    deleteListing: "Elimina annuncio...",
    notePrefix: "Elimina l'annuncio",
    noteSuffix: " e tutte le sue unità da WACheckin. Questa azione non può essere annullata.",
  },
  toast: {
    orderSaved: "Ordine salvato correttamente",
  },
  errors: {
    loadListing: "Impossibile caricare l'alloggio.",
  },
  authorities: {
    title: "Autorità",
    description: "Configura la connessione con le autorità locali per l'invio automatico della registrazione degli ospiti.",
  },
  cards: {
    knowledge: { title: "Base di conoscenza", status: "Informazioni utilizzate dall'agente" },
    earlyAccess: { title: "Accesso anticipato", status: "Orari di arrivo e check-in anticipato" },
    lateCheckout: { title: "Check-out posticipato", status: "Check-out posticipato e prezzo" },
    extendStay: { title: "Estendi il soggiorno", status: "Estendi le notti della prenotazione" },
    invoicing: { title: "Fatturazione", status: "Dati fiscali · compatibile con Verifactu" },
    location: { title: "Posizione", sub: "Indirizzo dell'alloggio" },
    logo: { title: "Branding", sub: "Identità visiva" },
    welcome: { title: "Messaggio di benvenuto", sub: "Personalizza il benvenuto" },
    checkin: { title: "Check-in", sub: "Istruzioni e orari di ingresso" },
    policies: { title: "Politiche dell'alloggio", sub: "Regole e condizioni" },
    authorities: { sub: "Registrazione presso le autorità" },
    hotelRates: { title: "Tariffe hotel", sub: "Tariffe base e derivate" },
    roomManagement: { title: "Camere", sub: "Tipi di camera e inventario" },
    rates: { title: "Tariffe", sub: "Tariffe base e derivate" },
    ota: { title: "Collega OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Richiede un abbonamento attivo" },
    ical: { title: "Calendario iCal", sub: "Sincronizzazione del calendario" },
    ownerSettlement: { title: "Proprietario e liquidazione", sub: "Se lo gestisci per un altro proprietario: commissione e liquidazione", subManaged: "Gestito per {owner} · {pct}%", subManagedNoOwner: "Gestito · {pct}% · nessun proprietario assegnato" },
    otaCommissions: { title: "Commissioni delle OTA", sub: "Quanto trattiene ogni OTA e quanto ti arriva", subActive: "La scheda mostra quanto ti arriva da ogni prenotazione" },
    description: { title: "Descrizione", sub: "Dettagli dell'unità" },
    capacity: { title: "Capacità", sub: "Ospiti e letti" },
    services: { title: "Dotazioni e comfort", sub: "Cosa offre, con le foto" },
    unitFaq: { title: "Domande e risposte", sub: "Specifiche per questa unità per l'agente" },
    rules: { title: "Orari", sub: "Orari di check-in e check-out" },
    upselling: { title: "Esperienze e servizi", sub: "Servizi di upselling" },
    checkinStore: { title: "Negozio del check-in", sub: "Invialo all'ospite all'arrivo" },
    bookingConfirmation: { title: "Notifica nuova prenotazione", sub: "Avvisiamo l'ospite su WhatsApp quando la sua prenotazione è confermata" },
    arrivalInstructions: { title: "Istruzioni per l'arrivo", sub: "Come arrivare ed entrare · con orario di invio" },
    checkoutMessage: { title: "Messaggio di check-out", sub: "Promemoria di check-out · modello" },
    scheduledMessages: { title: "Messaggi programmati", sub: "Messaggi automatici prima, durante e dopo il soggiorno" },
    review: { title: "Richiedi recensione", sub: "Reputazione dell'alloggio" },
    identity: { title: "Verifica dell'identità", sub: "Sicurezza degli ospiti" },
    journeySim: { title: "Simula il percorso dell'ospite", sub: "Riproduce l'intero processo su WhatsApp · invialo a un telefono per testarlo" },
    smartlocks: { title: "Serrature e accessi", sub: "Come entra l'ospite" },
    integrations: { title: "Connessioni e integrazioni", sub: "API e connessioni aggiuntive" },
    welcomeInline: { sub: "Messaggio specifico per questa unità" },
    newBookings: { title: "Nuove prenotazioni" },
  },
  badges: {
    ai: "IA",
    setup: "Configurazione",
    hotel: "Hotel",
    subscription: "Abbonamento",
    comingSoon: "Prossimamente",
    test: "Test",
    manager: "Gestore",
    active: "Attivo",
  },
  sections: {
    essential: { title: "Configurazione essenziale", description: "Impostazioni di base necessarie per pubblicare e gestire l'alloggio." },
    management: { title: "Gestione dell'alloggio", description: "Configura tariffe, disponibilità e canali di vendita." },
    direct: { title: "Dettaglia questa unità", description: "Informazioni aggiuntive che utilizziamo per le prenotazioni dirette e per alimentare l'Agente IA." },
    guest: { title: "Esperienza dell'ospite", description: "Configura la comunicazione prima, durante e dopo il soggiorno." },
    access: { title: "Accessi e integrazioni", description: "Gestisci accessi, serrature e connessioni esterne." },
  },
  otaModal: {
    title: "Connessione OTA",
    html: "Collegare Booking, Airbnb, Vrbo, Expedia (channel manager) richiede un <b>abbonamento attivo</b>.<br><small>Nel frattempo puoi usare le altre funzionalità e sincronizzare i calendari tramite iCal (gratis).</small>",
    confirm: "Attiva abbonamento",
    cancel: "Non ora",
  },
};
